import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';

const Navbar = styled.nav`
  background: #fff;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 1000;
  transition: all 0.3s ease;
  background: ${props => props.scrolled ? 'rgba(255, 255, 255, 0.95)' : '#fff'};
  backdrop-filter: ${props => props.scrolled ? 'blur(10px)' : 'none'};
`;

const NavContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 70px;
`;

const NavLogo = styled.div`
  h2 {
    color: #1e40af;
    font-weight: 700;
    font-size: 1.5rem;
    margin: 0;
  }
  
  span {
    color: #6b7280;
    font-size: 0.875rem;
    font-weight: 400;
  }
`;

const NavMenu = styled.ul`
  display: flex;
  list-style: none;
  gap: 2rem;
  margin: 0;
  padding: 0;

  @media (max-width: 768px) {
    position: fixed;
    left: ${props => props.isOpen ? '0' : '-100%'};
    top: 70px;
    flex-direction: column;
    background-color: white;
    width: 100%;
    text-align: center;
    transition: 0.3s;
    box-shadow: 0 10px 27px rgba(0,0,0,0.05);
    padding: 2rem 0;
  }
`;

const NavLink = styled.a`
  text-decoration: none;
  color: #374151;
  font-weight: 500;
  transition: color 0.3s ease;
  position: relative;
  cursor: pointer;

  &:hover {
    color: #1e40af;
  }

  &::after {
    content: '';
    position: absolute;
    bottom: -5px;
    left: 0;
    width: 0;
    height: 2px;
    background: #1e40af;
    transition: width 0.3s ease;
  }

  &:hover::after {
    width: 100%;
  }
`;

const Hamburger = styled.div`
  display: none;
  flex-direction: column;
  cursor: pointer;

  @media (max-width: 768px) {
    display: flex;
  }

  .bar {
    width: 25px;
    height: 3px;
    background: #374151;
    margin: 3px 0;
    transition: 0.3s;
    transform: ${props => props.isOpen ? 'rotate(45deg) translate(5px, 5px)' : 'none'};

    &:nth-child(2) {
      opacity: ${props => props.isOpen ? '0' : '1'};
    }

    &:nth-child(3) {
      transform: ${props => props.isOpen ? 'rotate(-45deg) translate(7px, -6px)' : 'none'};
    }
  }
`;

const Navigation = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const closeMenu = () => {
    setIsOpen(false);
  };

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const offsetTop = element.offsetTop - 70;
      window.scrollTo({
        top: offsetTop,
        behavior: 'smooth'
      });
    }
    closeMenu();
  };

  return (
    <Navbar scrolled={scrolled}>
      <NavContainer>
        <NavLogo>
          <h2>Tech Week GR</h2>
          <span>Engagement Committee</span>
        </NavLogo>
        
        <NavMenu isOpen={isOpen}>
          <li><NavLink onClick={() => scrollToSection('highlights')}>2025 Highlights</NavLink></li>
          <li><NavLink onClick={() => scrollToSection('lessons')}>Lessons Learned</NavLink></li>
          <li><NavLink onClick={() => scrollToSection('recommendations')}>2026 Recommendations</NavLink></li>
          <li><NavLink onClick={() => scrollToSection('meeting-notes')}>October Meeting</NavLink></li>
          <li><NavLink onClick={() => scrollToSection('timeline')}>12-Month Timeline</NavLink></li>
          <li><NavLink onClick={() => scrollToSection('contact')}>Contact</NavLink></li>
        </NavMenu>
        
        <Hamburger isOpen={isOpen} onClick={toggleMenu}>
          <span className="bar"></span>
          <span className="bar"></span>
          <span className="bar"></span>
        </Hamburger>
      </NavContainer>
    </Navbar>
  );
};

export default Navigation;
